module.exports = "/_next/static/images/DataPrivacy-9a03c689587d9c0d7e66d07ac7076ec6.webp";